import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BMSwitchCheckboxComponent } from './bm-switch-checkbox.component';

@NgModule({
  imports: [CommonModule],
  declarations: [BMSwitchCheckboxComponent],
  exports: [BMSwitchCheckboxComponent],
})
/**
 * Module of the Switch Component
 */
export class BMSwitchCheckboxModule {}
